import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * 🎯 Purpose:
 * Defines the list of widget component keys that support AI generative narratives
 */

export const WHITELISTED_AI_NARRATIVE_COMPONENT_KEYS: IComponentKey[] = [
    'riskHeatMap',
    'criticalityWeightedSCurve',
    'topCriticalActivitiesDelayDrivers',
    'progressSummary',
    'topOverdueOverrunActivities',
    'projectSummary',
    'keyAchievements',
    'activityPredecessors',
    'keyActivities',
    'finishDateOverallSummary',
    'productivityRate',
    'resourcesAnalysisChart',
    'trends',
];
